import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { stopPropagation } from '@fcom/core/utils/event';

import { StepperStep } from './interfaces';
import { StepperMode, StepperTheme } from './enums';

@Component({
  selector: 'fcom-stepper',
  styleUrls: ['./stepper.component.scss'],
  templateUrl: './stepper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StepperComponent {
  readonly StepperTheme = StepperTheme;
  readonly StepperMode = StepperMode;

  showLabels = input(true);
  steps = input<StepperStep[]>([]);
  activeStep = input(0);
  theme = input(StepperTheme.LIGHT);
  mode = input(StepperMode.HORIZONTAL);

  clicked = output<StepperStep>();

  selectStep(event: Event, step: StepperStep): void {
    stopPropagation(event);
    this.clicked.emit(step);
  }
}
